<template>
  <div class="hello">
    <h1>Login</h1>

    <h3 v-if="missingToken">Missing Token</h3>
    <h3 v-if="invalidToken">Invalid Token</h3>

  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'SSOPage',

  created() {

    if ('token' in this.$route.query) {
      const token = this.$route.query.token
      this.$store.dispatch("userSSO", { token: token }).then(() => {
        this.$store.dispatch("loadDomainsList").then(() => {

          if (this.loginError != '') {
            this.invalidToken = true
          }
          else {
            this.$router.push('/testseries');
          }
        });
      });
    }
    else {
      this.missingToken = true
    }

  },
  data: () => ({
    missingToken: false,
    invalidToken: false
  }),

  computed: {
    ...mapState(["userInfo", "loginError"]),

  },

  watch: {

  },

  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
